import React from 'react'
import Row from './Row'
import _ from 'lodash'

const Body = ({ students, ...rest }) => {
  return _.map(students, (child, index) => {
    const { id } = child.object
    return (
      <Row
        number={index + 1}
        key={id}
        student={child}
        { ...rest }
      />
    )
  })
}

export default Body
